const PasteventdetailsSr = () => { 
  // your component logic here
};

export default PasteventdetailsSr;
